import i18n from '../../i18n';

const messages = i18n.messages;

export const locale = i18n.locale;

export default messages[locale];



// WEBPACK FOOTER //
// ./src/services/i18n/index.js